{
  "id": "worktable1x1",
  "name": "Small Worktable",
  "builds": "machine",
  "category": "shopFurniture",
  "note": "Small, but it stands flat. That's a start.",
  "skill": "shopFurniture",
  "duration": 35,
  "offeredBy": "bench",
  "fastener": "nails",
  "widthIn": 24,
  "heightIn": 24,
  "slots": [
    {
      "id": "top-0",
      "role": "top",
      "part": {
        "widthIn": 24,
        "lengthIn": 24,
        "thicknessQ": 3
      },
      "stock": {
        "type": "plywood",
        "sheetGrade": "shopFurniture",
        "thickness": "any"
      },
      "xIn": 12,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 12,
      "yIn": 4,
      "angleDeg": 90,
      "zIn": 0.75,
      "onEdge": true
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 12,
      "yIn": 20,
      "angleDeg": 90,
      "zIn": 0.75,
      "onEdge": true
    },
    {
      "id": "stretcher-0",
      "role": "stretcher",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "length": [36, 48],
        "width": "any",
        "thickness": [6, 8]
      },
      "xIn": 12,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 4.75,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 6,
      "yIn": 4
    },
    {
      "xIn": 18,
      "yIn": 4
    },
    {
      "xIn": 6,
      "yIn": 20
    },
    {
      "xIn": 18,
      "yIn": 20
    },
    {
      "xIn": 12,
      "yIn": 4
    },
    {
      "xIn": 12,
      "yIn": 20
    }
  ]
}
